import { DropdownMenuItemType } from '@fluentui/react';
/**
 * Represents the map of different types of AI Harm categories for a VulnerabilityReport.
 *
 * @example
 * const category = metaVulnReportAIHarmCategory[report?.aiHarmCategory]?.displayName;
 */
export const metaVulnReportAIHarmCategory = {
    CBRN: {
        displayName: 'CBRN (Chemical, Biological, Radiological or Nuclear)',
    },
    InformationIntegrityGeneral: { displayName: 'Information Integrity' },
    InformationIntegrityElection: { displayName: 'Election Integrity' },
    HarmfulContentCSEAM: {
        displayName: 'CSEAM (Child Sexual Exploitation and Abuse Material) ',
    },
    HarmfulContentSexual: { displayName: 'Sexual content' },
    HarmfulContentHateSpeech: { displayName: 'Hate Speech' },
    HarmfulContentSelfHarm: { displayName: 'Self-harm' },
    HarmfulContentIncitingViolence: { displayName: 'Inciting Violence' },
    HarmfulContentInappropriateLanguage: {
        displayName: 'Inappropriate Language',
    },
    Fairness: { displayName: 'Fairness' },
    MaliciousUses: { displayName: 'Malicious Uses' },
};
/**
 * A FluentUI dropdown options array for the AI Harm category. This includes section headers.
 */
export const vulnReportAIHarmCategoryOptions = [
    {
        key: 'CBRN header',
        text: metaVulnReportAIHarmCategory.CBRN.displayName,
        itemType: DropdownMenuItemType.Header,
    },
    {
        key: 'CBRN',
        text: metaVulnReportAIHarmCategory.CBRN.displayName,
        data: 'CBRN',
    },
    {
        key: 'InformationIntegrityGeneral header',
        text: 'Information Integrity',
        itemType: DropdownMenuItemType.Header,
    },
    {
        key: 'InformationIntegrityGeneral',
        text: metaVulnReportAIHarmCategory.InformationIntegrityGeneral
            .displayName,
        data: 'InformationIntegrityGeneral',
    },
    {
        key: 'InformationIntegrityElection',
        text: metaVulnReportAIHarmCategory.InformationIntegrityElection
            .displayName,
        data: 'InformationIntegrityElection',
    },
    {
        key: 'HarmfulContent header',
        text: 'Harmful Content',
        itemType: DropdownMenuItemType.Header,
    },
    {
        key: 'HarmfulContentCSEAM',
        text: metaVulnReportAIHarmCategory.HarmfulContentCSEAM.displayName,
        data: 'HarmfulContentCSEAM',
    },
    {
        key: 'HarmfulContentSexual',
        text: metaVulnReportAIHarmCategory.HarmfulContentSexual.displayName,
        data: 'HarmfulContentSexual',
    },
    {
        key: 'HarmfulContentHateSpeech',
        text: metaVulnReportAIHarmCategory.HarmfulContentHateSpeech.displayName,
        data: 'HarmfulContentHateSpeech',
    },
    {
        key: 'HarmfulContentSelfHarm',
        text: metaVulnReportAIHarmCategory.HarmfulContentSelfHarm.displayName,
        data: 'HarmfulContentSelfHarm',
    },
    {
        key: 'HarmfulContentIncitingViolence',
        text: metaVulnReportAIHarmCategory.HarmfulContentIncitingViolence
            .displayName,
        data: 'HarmfulContentIncitingViolence',
    },
    {
        key: 'HarmfulContentInappropriateLanguage',
        text: metaVulnReportAIHarmCategory.HarmfulContentInappropriateLanguage
            .displayName,
        data: 'HarmfulContentInappropriateLanguage',
    },
    {
        key: 'Fairness header',
        text: metaVulnReportAIHarmCategory.Fairness.displayName,
        itemType: DropdownMenuItemType.Header,
    },
    {
        key: 'Fairness',
        text: metaVulnReportAIHarmCategory.Fairness.displayName,
        data: 'Fairness',
    },
    {
        key: 'MaliciousUses header',
        text: metaVulnReportAIHarmCategory.MaliciousUses.displayName,
        itemType: DropdownMenuItemType.Header,
    },
    {
        key: 'MaliciousUses',
        text: metaVulnReportAIHarmCategory.MaliciousUses.displayName,
        data: 'MaliciousUses',
    },
];
